import FileInfo from "./FileInfo";
import UrlColumnSelect from "./UrlColumnSelect";
import VariablesPreview from "./VariablesPreview";

import type { Dispatch, SetStateAction } from "react";
import type { CsvState } from "../../../../types";

interface CsvOverviewProps {
  csvState: CsvState;
  setCsvState: Dispatch<SetStateAction<CsvState>>;
  onChange: () => void;
  isFileError: boolean;
  isInstantly?: boolean;
}

export default function CsvOverview({
  csvState,
  setCsvState,
  onChange,
  isFileError,
  isInstantly = false,
}: CsvOverviewProps) {
  const {
    fileName,
    missing_data,
    url_columns,
    mainIdentifier,
    columns,
    row_count,
  } = csvState;

  return (
    <section className="mx-auto flex w-full max-w-[790px] flex-col gap-y-4">
      <FileInfo
        isInstantly={isInstantly}
        name={fileName}
        missingData={missing_data}
        rowsCount={row_count}
        isFileError={isFileError}
        changeFile={onChange}
      />

      {columns.length > 1 && !isFileError && (
        <>
          <UrlColumnSelect
            options={url_columns}
            urlColumn={mainIdentifier}
            onSelect={(value) =>
              setCsvState({ ...csvState, mainIdentifier: value })
            }
          />

          <VariablesPreview
            variables={columns.filter((column) => column !== mainIdentifier)}
          />
        </>
      )}
    </section>
  );
}
